import React, { useContext } from 'react';

import type { DisclaimerContextType } from '../../../context/disclaimer.context';

import { BodySlice } from '@ww-digital/web-palette-react/dist/components/Slice/BodySlice/BodySlice';
import { DisclaimerContext } from '../../../context/disclaimer.context.ts';

import styles from './PlansDisclaimerSliceContainer.module.scss';

interface PlansDisclaimerSliceContainerProps {
  slice: {
    id: string;
    dataSourceSliceId?: string;
  };
  daCategory: string;
  category?: string;
  topLevelCategory?: string;
  region?: string;
  type: string;
  contentId?: string;
}

export const PlansDisclaimerSliceContainer = ({
  slice,
  daCategory,
  category,
  topLevelCategory,
  region,
  type,
  contentId,
}: PlansDisclaimerSliceContainerProps): JSX.Element => {
  const { getSliceDisclaimer } =
    useContext<DisclaimerContextType>(DisclaimerContext);

  // Get the disclaimer for this specific slice using the dataSourceSliceId
  const disclaimer = slice.dataSourceSliceId
    ? getSliceDisclaimer(slice.dataSourceSliceId)
    : '';

  const sliceView = {
    headline: {
      align: 'left',
      ariaLevel: 3,
      text: null,
      typog: 'headline5',
      variant: 'default',
    },
    body: disclaimer,
  };

  return (
    <div className={styles.container}>
      <BodySlice {...sliceView} />
    </div>
  );
};
